module.exports = __webpack_public_path__ + "img/iospwa.efb20889.png";